import AddinRecurrence from './schema/AddinRecurrence';
import createDateFromSeriesTimeData from './builders/createDateFromSeriesTimeData';
import createRecurrencePattern from './builders/createRecurrencePattern';
import createRecurrenceRange from './builders/createRecurrenceRange';
import ExchangeRecurrenceBundle from './schema/ExchangeRecurrenceBundle';

export default function convertRecurrenceToExchangeFormat(
    recurrence: AddinRecurrence
): ExchangeRecurrenceBundle {
    if (recurrence == null) {
        return null;
    }
    const { seriesTimeJson, recurrenceProperties, recurrenceType } = recurrence;

    const { startDay, startMonth, startYear, startTimeMin, durationMin } = seriesTimeJson;

    return {
        recurrenceType: {
            __type: 'RecurrenceType:#Exchange',
            RecurrenceRange: createRecurrenceRange(seriesTimeJson),
            RecurrencePattern: createRecurrencePattern(recurrenceType, recurrenceProperties),
        },
        startTime: createDateFromSeriesTimeData(startYear, startMonth, startDay, startTimeMin),
        endTime: createDateFromSeriesTimeData(
            startYear,
            startMonth,
            startDay,
            startTimeMin + durationMin
        ),
    };
}
